import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=251d257a&scoped=true&"
import script from "./Action.vue?vue&type=script&lang=js&"
export * from "./Action.vue?vue&type=script&lang=js&"
import style0 from "./Action.vue?vue&type=style&index=0&id=251d257a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251d257a",
  null
  
)

export default component.exports